module.exports = __webpack_public_path__ + "static/media/logo-emd-pure.5fc26534.svg";